import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import User from "./User";
import Notification from "./Notification";
import Model from "./Model";
export class UserNotification extends Model {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "Id", {
      fieldName: 'user_notifications_id',
      fieldTitle: 'Notification Id',
      content: null
    });
    _defineProperty(this, "UserNotificationId", {
      fieldName: 'user_notifications_id',
      fieldTitle: 'Notification Id',
      content: null
    });
    _defineProperty(this, "creatorId", {
      fieldName: 'user_id',
      fieldTitle: 'Notification Id',
      content: null
    });
    _defineProperty(this, "UserNotificationUser", {
      fieldName: 'user_notification_user',
      fieldTitle: 'Notification User',
      model: User,
      content: null
    });
    _defineProperty(this, "UserNotificationNotification", {
      fieldName: 'user_notification_notification',
      fieldTitle: 'Notification',
      model: Notification,
      content: null
    });
    _defineProperty(this, "readAt", {
      fieldName: 'read_at',
      fieldTitle: 'Notification Read At',
      content: null
    });
  }
  getReadDate() {
    return this.readAt.content;
  }
  getCreator() {
    return this.UserNotificationUser.content;
  }
  getCreatorId() {
    var _this$creatorId$conte;
    let creator = this.getCreator();
    return (_this$creatorId$conte = this.creatorId.content) !== null && _this$creatorId$conte !== void 0 ? _this$creatorId$conte : creator instanceof User ? creator.getId() : null;
  }
}
export default UserNotification;